// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const Save = (): ReactElement => (
    <FormattedMessage id="apps.lensVisibility.components.save" description="Save." defaultMessage="Save" />
);
Save.displayName = "Save";

export const Cancel = (): ReactElement => (
    <FormattedMessage id="apps.lensVisibility.components.cancel" description="Cancel." defaultMessage="Cancel" />
);
Cancel.displayName = "Cancel";

export const DigitalGoodsVisibilityHiddenDisabledMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.digitalGoodsVisibilityHiddenDisabledMessage"
        description="Digital goods visibility hidden disabled message."
        defaultMessage="This lens cannot be set Hidden because it contains one or more Digital Goods"
    />
);
DigitalGoodsVisibilityHiddenDisabledMessage.displayName = "DigitalGoodsVisibilityHiddenDisabledMessage";

export const VisibilityPublic = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityPublic"
        description="Visibility public."
        defaultMessage="Public"
    />
);
VisibilityPublic.displayName = "VisibilityPublic";

export const VisibilityPublicDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityPublicDescription"
        description="Visibility public description."
        defaultMessage="All Snapchatters can find and share this lens"
    />
);
VisibilityPublicDescription.displayName = "VisibilityPublicDescription";

export const VisibilityHidden = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityHidden"
        description="Visibility hidden."
        defaultMessage="Hidden"
    />
);
VisibilityHidden.displayName = "VisibilityHidden";

export const VisibilityHiddenDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityHiddenDescription"
        description="Visibility hidden description."
        defaultMessage="Users with the QR code or Lens Link can use this Lens"
    />
);
VisibilityHiddenDescription.displayName = "VisibilityHiddenDescription";

export const VisibilityOffline = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityOffline"
        description="Visibility offline."
        defaultMessage="Offline"
    />
);
VisibilityOffline.displayName = "VisibilityOffline";

export const VisibilityOfflineDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityOfflineDescription"
        description="Visibility offline description."
        defaultMessage="No one can use the Lens. The QR code is deactivated"
    />
);
VisibilityOfflineDescription.displayName = "VisibilityOfflineDescription";

export const VisibilityDoNotPublishToSnapchat = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityDoNotPublishToSnapchat"
        description="Visibility do not publish to snapchat."
        defaultMessage="Do not publish to Snapchat"
    />
);
VisibilityDoNotPublishToSnapchat.displayName = "VisibilityDoNotPublishToSnapchat";

export const VisibilityDoNotPublishToSnapchatDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensVisibility.components.visibilityDoNotPublishToSnapchatDescription"
        description="Visibility do not publish to snapchat description."
        defaultMessage="The Lens will be uploaded to Lens Folder only"
    />
);
VisibilityDoNotPublishToSnapchatDescription.displayName = "VisibilityDoNotPublishToSnapchatDescription";
